import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API } from '../api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { LogIn, Mail, Lock } from 'lucide-react';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
      });

      if (response.data.success) {
        toast.success(response.data.message);
        onLogin(response.data.user);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Errore durante il login';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#D94E1F] to-[#B83E15] items-center justify-center p-12">
        <div className="text-white max-w-md">
          <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Manrope' }}>
            Software Gestione Familiare
          </h1>
          <p className="text-xl opacity-90">
            Gestisci le spese della tua famiglia in modo semplice ed efficace
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <img
              src="https://maxvalle.it/wp-content/uploads/2026/01/verticale-arancio-scuro-2.png"
              alt="Logo"
              className="h-24 mx-auto mb-6"
              data-testid="login-logo"
            />
            <h2 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope' }}>
              Accedi al tuo Account
            </h2>
            <p className="text-slate-600">Inserisci le tue credenziali per continuare</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-slate-700 font-medium flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#D94E1F]" />
                Email
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 rounded-lg border-slate-200 focus:ring-2 focus:ring-[#D94E1F]/20 focus:border-[#D94E1F] transition-all bg-slate-50/50 focus:bg-white"
                placeholder="tua@email.com"
                required
                data-testid="email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-slate-700 font-medium flex items-center gap-2">
                <Lock className="w-4 h-4 text-[#D94E1F]" />
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 rounded-lg border-slate-200 focus:ring-2 focus:ring-[#D94E1F]/20 focus:border-[#D94E1F] transition-all bg-slate-50/50 focus:bg-white"
                placeholder="••••••••"
                required
                data-testid="password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#D94E1F] hover:bg-[#B83E15] text-white rounded-full px-6 py-3 font-medium transition-all shadow-sm hover:shadow-md"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? (
                'Accesso in corso...'
              ) : (
                <>
                  <LogIn className="w-4 h-4 mr-2" />
                  Accedi
                </>
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-slate-600">
              Prima registrazione?{' '}
              <Link
                to="/register"
                className="text-[#D94E1F] hover:underline font-medium"
                data-testid="register-link"
              >
                Attiva la tua licenza
              </Link>
            </p>
            <p className="text-xs text-slate-500 mt-3">
              Non hai una licenza?{' '}
              <a
                href="https://clienti.maxvalle.it/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#D94E1F] hover:underline"
              >
                Acquista ora
              </a>
              {' '}•{' '}
              <a
                href="https://clienti.maxvalle.it/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#D94E1F] hover:underline"
              >
                Apri ticket Area Clienti
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
